import React from 'react';
import { Navbar } from '@/pages/Home/components/Navbar/Navbar';
import { Footer } from '@/pages/Home/components/Footer/Footer';
import { FeaturesHero } from './components/FeaturesHero/FeaturesHero';
import { FeaturesOverview } from './components/FeaturesOverview/FeaturesOverview';
import { PoseStudio } from './components/PoseStudio/PoseStudio';
import './FeaturesPage.css';

export function FeaturesPage() {
  return (
    <div className="features-page">
      <Navbar />
      <main className="features-page__main">
        <FeaturesHero />
        <FeaturesOverview />
        <PoseStudio />
      </main>
      <Footer />
    </div>
  );
}

export default FeaturesPage;
